import { ContentPage } from '../page-factory/content-page';
import { maghiPurnimaPage } from '../pages/page-magh-mela.bathing-dates';
import { MetaFunction } from '@remix-run/cloudflare';

export const meta: MetaFunction = () => {
  return [
    { title: 'Maghi Purnima - Magh Mela 2026 - Kumbh Sukrit' },
    {
      name: 'description',
      content:
        'Join us for Maghi Purnima at Magh Mela 2026. The culmination day for Kalpwasis and an important bathing date.',
    },
    {
      tagName: 'link',
      rel: 'canonical',
      href: 'https://kumbhsukrit.com/magh-mela-2026/maghi-purnima',
    },
  ];
};

export default function MaghiPurnimaPage() {
  return <ContentPage {...maghiPurnimaPage} />;
}
